export const TOTAL_TIME = {
  value: 0,
  title: "Общее время",
};
export const AVERAGE_PACE = {
  value: 1,
  title: "Средний темп",
};
export const CUTOFFS_1_KM = {
  value: 2,
  title: "Отсечки по 1 км",
};
export const CUTOFFS_5_KM = {
  value: 3,
  title: "Отсечки по 5 км",
};
